import { useState } from "react";

const Montlyplan = ({ monthly, selectedPlan, onSelectPlan, symbol }) => {
  return (
    <div className="w-full bg-white rounded-xl border p-4 space-y-3">
      {monthly.map((plan) => {
        const isActive = selectedPlan?.meal_plan_id === plan.meal_plan_id;

        const perMeal = Number(plan.plan_amount) / plan.order_count;

        return (
          <button
            key={plan.meal_plan_id}
            onClick={() =>
              onSelectPlan({
                meal_plan_id: plan.meal_plan_id,
                order_count: plan.order_count,
                plan_amount: Number(plan.plan_amount),
                perMealPrice: perMeal,
              })
            }
            className={`w-full flex justify-between items-center rounded-xl border px-4 py-3
              ${isActive ? "border-orange-500 bg-orange-50" : "border-gray-200"}
            `}
          >
            <div className="flex gap-3 items-center">
              <div
                className={`h-4 w-4 rounded-full border ${isActive && "border-orange-500"}`}
              >
                {isActive && (
                  <div className="h-2 w-2 bg-orange-500 rounded-full m-auto mt-[3px]" />
                )}
              </div>

              <div className="text-left">
                <p className="text-sm font-medium">{plan.order_count} Meals</p>
                <p className="text-xs text-gray-500">
                  {symbol} {perMeal.toFixed(2)} / Meal
                </p>
              </div>
            </div>

            <span className="text-orange-600 font-semibold">
              {symbol}
              {plan.plan_amount}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default Montlyplan;
